module.exports = __webpack_public_path__ + "static/01-292eba79e7b7f7d450cbf202422cc93c.jpg";